module.exports = __webpack_public_path__ + "static/media/Threshold-Met.99124d48.svg";